import type {TextFieldState} from '@superweb/ui'
import {debounce} from '@yandex-delivery/utils'
import {useMemo, useState} from 'react'

import {type ZonesInfo} from '../../../../../../../api'

const DEBOUNCE_DELAY = 300

type UseCitySearchParams = {
  zones: ZonesInfo
  cityToNavListItem: (city: any) => any
}

/**
 * Хук для управления логикой поиска городов.
 */
export function useCitySearch({zones, cityToNavListItem}: UseCitySearchParams) {
  const [inputValue, setInputValue] = useState('') // Real time значение инпута поиска
  const [searchValue, setSearchValue] = useState('')
  const [filteredCities, setFilteredCities] = useState<any>()

  // Debounced-функция для фильтрации
  const filterCities = useMemo(
    () =>
      debounce((value: string) => {
        setSearchValue(value)

        const result = zones.allZones
          .filter(zone => zone.title.toLowerCase().startsWith(value.toLowerCase()))
          .map(cityToNavListItem)

        setFilteredCities(result)
      }, DEBOUNCE_DELAY),
    [cityToNavListItem, zones],
  )

  const onInputChange = (state: TextFieldState) => {
    setInputValue(state.value)
    filterCities(state.value)
  }

  return {
    inputValue,
    onInputChange,
    searchValue,
    filteredCities,
  }
}
